import React from "react";

export default function StatCard({ label, value, icon: Icon, accent, testid, hint, delta }) {
  return (
    <div
      className="card-soft card-soft-hover p-5"
      data-testid={testid}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="text-[11px] uppercase tracking-[0.14em] text-[#718096] font-semibold">
            {label}
          </div>
          <div className="mt-2 font-display text-2xl text-[#1a202c]">
            {value}
            {delta != null && (
              <span
                className={`ml-2 text-xs font-semibold ${
                  delta >= 0 ? "text-[#48bb78]" : "text-[#f56565]"
                }`}
              >
                {delta >= 0 ? "+" : ""}
                {delta}%
              </span>
            )}
          </div>
          {hint && <div className="text-xs text-[#a0aec0] mt-1">{hint}</div>}
        </div>
        {Icon && (
          <div
            className="h-11 w-11 rounded-xl flex items-center justify-center shrink-0 bg-brand text-white shadow-[0_6px_14px_-4px_rgba(56,178,172,0.5)]"
            style={accent ? { background: accent } : undefined}
          >
            <Icon className="h-5 w-5" strokeWidth={2} />
          </div>
        )}
      </div>
    </div>
  );
}
